import React, { FC } from 'react';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import { InjectedFieldProps, PublicFieldProps } from 'react-admin';
import { JobPhaseReceivableSheetInterface } from '@vatos-pas/common';

import { PermissionsProvider } from 'providers/permissionsProvider';
import { CAN_EDIT_RECEIVABLE } from 'providers/permissions';

import { useInvoiceDraft } from '../hooks/useInvoiceRow';
import { formatCurrency } from 'utils/currency';

type InvoicePOAmountFieldProps = PublicFieldProps &
  InjectedFieldProps<JobPhaseReceivableSheetInterface>;

const useStyles = makeStyles({
  input: {
    width: 120,
  },
});

export const InvoicePOAmountField: FC<InvoicePOAmountFieldProps> = ({
  record,
}) => {
  const classes = useStyles();
  const { hasPermission } = PermissionsProvider.useContainer();
  const canEdit = hasPermission(CAN_EDIT_RECEIVABLE);
  const { poAmountInput, errors, submitting, setPoAmountInput } =
    useInvoiceDraft(record, canEdit);

  if (!record) return null;

  if (!canEdit) {
    return <span>{formatCurrency(record.invoicePOAmount)}</span>;
  }

  return (
    <Box className={classes.input}>
      <TextField
        // Plain text, NOT type="number": a number input makes the browser
        // re-render the value in the OS/Chrome locale, surfacing a comma
        // decimal separator (e.g. "232323,00"). The onChange filter keeps
        // entry numeric; a leading "-" stays typeable so the negative-PO
        // validation still fires on save.
        value={poAmountInput}
        onChange={event => {
          const next = event.target.value;
          if (next === '' || /^-?\d*([.,]\d{0,2})?$/.test(next)) {
            setPoAmountInput(next);
          }
        }}
        inputProps={{ inputMode: 'decimal' }}
        disabled={submitting}
        error={Boolean(errors.poAmount)}
        helperText={errors.poAmount ?? ''}
        placeholder="0.00"
      />
    </Box>
  );
};

export default InvoicePOAmountField;
